<div class="container">
  <mat-card>
    <form [formGroup]="groupsAddRoleForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Client' | translate }}</mat-label>
            <mat-select formControlName="clientId">
              @for (client of clientMemberData; track client) {
                <mat-option [value]="client.id">
                  {{ client.displayName }}
                </mat-option>
              }
            </mat-select>
            @if (groupsAddRoleForm.controls.clientId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Client Member' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Role' | translate }}</mat-label>
            <mat-select formControlName="role">
              @for (role of roleData; track role) {
                <mat-option [value]="role.id">
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
            @if (groupsAddRoleForm.controls.role.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Role' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!groupsAddRoleForm.valid"
          *LOSxHasPermission="'ASSIGNROLE_GROUP'"
        >
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
